<template>
  <div class="password-page">
    <TheAppBar />

    <v-content class="password-page__content" transition="out-in">
      <v-container fill-height>
        <v-row>
          <v-col class="text-center">
            <v-form
              ref="passwordRecoveryForm"
              class="password-page__form"
              v-model="isFormValid"
              lazy-validation
              @submit.prevent="submitForm"
              @keyup.native.enter="submitForm"
            >
              <div class="password-page__img-container">
                <img src="@/assets/img/login-form-img.svg" alt="Login image">
              </div>
              <h1 class="password-page__title">{{ title }}</h1>
              <v-text-field
                v-model="user.password"
                class="form-field mb-3"
                :rules="[rules.required, rules.password]"
                validate-on-blur
                dense
                type="password"
                label="New password*"
                placeholder="Type password..."
              />
              <v-text-field
                v-model="user.password_confirmation"
                class="form-field"
                :rules="[rules.required, equalPasswordRule]"
                validate-on-blur
                dense
                type="password"
                label="Confirm new password*"
                placeholder="Type password..."
              />

              <v-btn
                class="password-page__submit"
                color="blue"
                x-large
                block
                :min-width="255"
                :loading="isSubmitProccesing"
                type="submit"
              >
                CHANGE
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import TheAppBar from '@/components/TheAppBar.vue';

const rules = validationRules;

export default {
  metaInfo: {
    title: 'Change password',
  },

  components: {
    TheAppBar,
  },

  props: {
    token: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      rules,
      user: {
        password: '',
        password_confirmation: '',
      },
      title: 'Change password',
      isFormValid: true,
      isSubmitProccesing: false,
    };
  },

  computed: {
    equalPasswordRule() {
      return this.user.password_confirmation === this.user.password || 'Passwords don`t match';
    },
  },

  mounted() {
    this.$store.dispatch('general/changeLoadingStatus', true);

    this.checkToken(this.token)
      .catch(() => {
        this.$router.push({ name: 'login' });
      })
      .finally(() => {
        this.$store.dispatch('general/changeLoadingStatus', false);
      });
  },

  methods: {
    ...mapActions('password', [
      'checkToken',
      'updatePassword',
    ]),

    submitForm() {
      this.$refs.passwordRecoveryForm.validate();

      if (this.isFormValid) {
        this.isSubmitProcessing = true;
        const passwordData = {
          token: this.token,
          password: this.user.password,
          password_confirmation: this.user.password_confirmation,
        };

        this.updatePassword(passwordData)
          .then(() => {
            this.$router.push({ name: 'login' });
          })
          .catch(() => {
            this.isSubmitProccesing = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password-page {
  background: #FCFCFC;
  &__content {
    min-height: calc(100vh - 64px);
  }

  &__form {
    background: #fff;
    max-width: 445px;
    margin: 0 auto;
    box-shadow: 0px 2px 4px #00000029;
    border-radius: 8px;
    padding: 16px 20px;

    @include tablet {
      padding: 32px 80px;
    }
  }

  &__title {
    text-align: left;
    margin-bottom: 16px;
    margin-top: 8px;
  }

  &__submit {
    margin-bottom: 6px;
    margin-top: 24px;
    font-weight: 500;
    color: white;
  }
}
</style>
